import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/demand-planning/noos/")({
  loader: ({ location }) => {
    if (location.pathname === "/demand-planning/noos") {
      throw redirect({
        to: "/demand-planning/noos/timeline",
      })
    }
    return null
  },
})
